import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../../shared/utils/helpers';

const CreateInvoiceMutation = (input, file) =>
  new Promise((resolve, reject) => {
    commitMutation(getEnvironment(), {
      mutation: graphql`
        mutation CreateInvoiceMutation($input: CreateInvoiceInput!) {
          createInvoice(input: $input) {
            clientMutationId
          }
        }
      `,
      variables: { input },
      uploadables: {
        invoice_file: file
      },
      onCompleted: resolve,
      onError: reject
    });
  });

export default CreateInvoiceMutation;
